import Landing from "./landing/Landing";

function Home() {
  return <Landing />;
}

export default Home;
